import moment from "moment";
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import DropdownSelect from "../../components/dropdown/Dropdown";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import Checkbox from "../../components/UIComponent/Checkbox";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { isNullNumber, isNullString } from "../../utils/Utils";
import { saveAs } from "file-saver";
import { encryptAES } from "../../utils/Encryption";
import ModalBasic from "../component/FormModal";
import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import ValidationText from '../../utils/validation/ValidationText';
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";
export default class CreditNoteApproval extends Component {
  constructor(props) {
    super(props);
    this.financeService = new FinanceServices();
    this.commonServices = new CommonServices();
    this.swalServices = new SwalServices();
    this.state = {
      creditNoteStatusList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        creditNoteStatusId: 0,
        creditNoteNumber: "",
        approvalEmailFilter: "",
      },
      actionDropdownApproved: [ "View Credit Note" ],
      actionDropdownForSent: [ "Closed" ],
      route: "",
      creditNoteList: [],
      totalResults: 0,
      selectedIdList: [],
      checkedRow: false,
      checkedHeader: false,
      isRejected: true,
      isApprove: true,
      isLoading: false,
      isApproveCreditNote: false,
      filePath: "",
      comments: "",
      fileDisplayName: "",
      validationRule: {
        comments: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "comments"
            ),
          },

        ],
        filePath: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "filePath"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      updateCreditNoteRequest: {
        financeCreditNoteId: 0,
        creditNoteRefundAmount: 0,
        creditNoteRefundMethod: "",
        bankNameId: 0,
        offsetInvoiceId: 0,
        creditNoteOffsetInvoiceAmount: 0,
        creditNoteInvoiceNo: "",
        creditNoteImage: "",
        creditNoteOpenCreditAmout: 0
      },
      isLoaderUpdateCreditNote: false,
      currentAdminEmail: "",
      currentAdminName: "",
      adminUserId: ""
    };


  }




  validateFieldOutstandingDetails = (key) => {
    let details = {
      comments: this.state.comments,
      filePath: this.state.filePath
    }

    const newValidState = validate(
      key,
      details,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  issAllvalidateFieldOutstandingDetails = () => {

    let details = {
      comments: this.state.comments,
      filePath: this.state.filePath
    }
    const newValidState = isValidForm(
      details,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };


  getAllFinanceCreditNoteList = () => {
    this.setState({ isLoading: true });
    this.financeService.getAllFinanceCreditNoteList(this.state.pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.responseItem.responseContent !== null) {
          let data = response.responseItem.responseContent.itemList;
          data.map((x) => {
            x.creditNoteMonth = moment(x.creditNoteMonth).format("DD MMM YYYY");
            x.isSelected = false;
            x.approvalDate = x.approvalDate === 'Invalid date' || x.approvalDate === null ? '-' : moment(x.approvalDate).format("DD MMM YYYY");
            return x;
          });
          this.setState({ creditNoteList: data, totalResults: response.responseItem.responseContent.totalCount });
        }

      } else {
        this.swalServices.Error("Something went wrong.");
      }
      this.setState({ isLoading: false });
    })
  }

  getFinanceCreditNoteStatusList = () => {
    this.financeService.getFinanceCreditNoteStatusList().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({ creditNoteStatusList: response.responseItem.responseContent }, () => { this.getAllFinanceCreditNoteList() });
      } else {
        this.getAllFinanceCreditNoteList()
        this.swalServices.Error("Something went wrong.");
      }
    })
  }

  onFileChange = (event) => {

    const file = event.target.files[ 0 ];
    if (file && (file.type === "image/jpeg" || file.type === "image/png" || file.type === "application/pdf")) {
      let request = {};
      request.storagePath = "CreditNoteImages";
      request.file = file;
      request.fileName = file.name;

      this.commonServices.uploadPDF(request).then((response) => {
        if (response != null) {
          if (request.storagePath === "CreditNoteImages") {
            let detail = { ...this.state.singleOutstandingInvoiceDetails };
            detail[ "filePath" ] = response.fileName;
            detail[ "fileDisplayName" ] = file.name;

            this.setState({ filePath: response.fileName, fileDisplayName: file.name }, () => {
              this.swalServices.Success("File Uploaded");
            });
          }
        } else {
          this.swalServices.Error(response.message);
        }
      });
    } else {
      this.swalServices.Error("Please select only Image or PDF");
    }
  };

  approveCreditNote = () => {
    this.setState({ isApproveCreditNote: true });
  }

  getFinanceCreditNoteById = (creditNoteId) => {
    return new Promise((resolve, reject) => {
      if (!creditNoteId || isNullNumber(creditNoteId) === 0) {
        resolve();
        return;
      }

      this.financeService.getFinanceCreditNoteById(creditNoteId)
        .then(async (response) => {
          if (response.statusCode !== 200 || !response.responseItem?.responseContent) {
            resolve();
            return;
          }

          const content = response.responseItem.responseContent;
          let data = { ...this.state.updateCreditNoteRequest };

          data.creditNoteRefundAmount = content.creditNoteTotalRefund;
          data.creditNoteOffsetInvoiceAmount = content.creditNoteOffsetInvoiceAmount || 0;
          content.creditNoteOpenCreditAmout = content.creditNoteTotalRefund - data.creditNoteRefundAmount;
          data.creditNoteOpenCreditAmout = content.creditNoteOpenCreditAmout;
          data.membershipPaymentTypeId = content.membershipPaymentTypeId;

          let unpaidInvoiceData = content.financeUnpaidInvoiceList?.map(x => ({
            ...x,
            invoiceDate: moment(x.invoiceDate).format("DD MMM YYYY"),
            isSelected: !!x.isPaidByOffset
          })) || [];

          this.setState({
            creditNote: content,
            totalAmount: content.creditNoteOpenCreditAmout,
            financeUnpaidInvoiceList: unpaidInvoiceData,
            updateCreditNoteRequest: data,
            totalRefundAmount: data.creditNoteRefundAmount,
            creditNoteImage: content.creditNoteImage,
            comments: content.comments,
          }, async () => {
            try {
              // Call updateCreditNote and wait for it
              await this.updateCreditNote({
                adminEmail: this.state.currentAdminEmail,
                adminName: this.state.currentAdminName,
                financeCreditNoteId: content.financeCreditNoteId,
                creditNoteOpenCreditAmout: data.creditNoteOpenCreditAmout,
                creditNoteStatusId: 3,
                creditNoteRefundAmount: data.creditNoteRefundAmount,
                creditNoteRefundMethod: data.creditNoteRefundMethod,
                bankNameId: data.bankNameId || 0,
                OffsetInvoiceId: data.offsetInvoiceId,
                invoiceNoForCreditNote: data.creditNoteInvoiceNo,
                creditNoteOffsetInvoiceAmount: data.creditNoteOffsetInvoiceAmount,
                createdBy: this.state.adminUserId,
                createdAppId: 114,
                createdAt: new Date(),
                membershipPaymentTypeId: data.membershipPaymentTypeId,
              });

              // Optionally update status list
              await this.getFinanceCreditNoteStatusList();

              resolve();
            } catch (error) {
              reject(error);
            }
          });
        })
        .catch(err => reject(err));
    });
  };



  updateCreditNote = (request) => {
    return new Promise((resolve, reject) => {
      if (!request) {
        resolve();
        return;
      }

      this.setState({ isLoaderUpdateCreditNote: true });

      this.financeService.financeUpdateCreditNote(request)
        .then(response => {
          this.setState({ isLoaderUpdateCreditNote: false });

          if (response.statusCode !== 200 || !response.responseItem?.responseContent) {
            this.swalServices.Error(response.message || "Failed to update credit note.");
            resolve();
            return;
          }

          const content = response.responseItem.responseContent;
          this.setState({ updatedCreditNote: content });
          this.swalServices.Success("Credit note updated.");

          // Only create payment proof mapping if needed
          if (content.membershipPaymentTypeId !== 5 && request.creditNoteOffsetInvoiceAmount > 0) {
            const reconciliationReq = {
              corporateMemberId: content.corporateMemberId,
              individualMemberId: content.individualMemberId,
              eventId: content.eventId,
              membershipPaymentTypeId: content.membershipPaymentTypeId,
              PaymentProofStatusId: 2,
              bookingId: content.bookingId,
              firstName: content.attentionTo,
              lastName: ' ',
              email: content.emailAddress,
              financeCreditNoteId: this.state.creditNote.financeCreditNoteId,
              amountCollected: request.creditNoteOffsetInvoiceAmount,
            };

            this.financeService.financeAddCreditNotePaymentProofMapping(reconciliationReq)
              .then(() => resolve())
              .catch(err => reject(err));
          } else {
            resolve();
          }
        })
        .catch(err => {
          this.setState({ isLoaderUpdateCreditNote: false });
          reject(err);
        });
    });
  };



  financeApproveRejectCreditNoteApproval = async (identity) => {
    if (!this.issAllvalidateFieldOutstandingDetails()) return;

    let isCheckForApproval = true;

    const selectedNotes = this.state.creditNoteList.filter(x => x.isSelected);
    const cookie = getAuthProps();
    const adminUserName = cookie?.userName || '';
    const adminUserId = cookie?.adminUserId || '';

    // Check if admin is authorized for all selected notes
    selectedNotes.forEach(x => {
      if (x.approvalEmail !== adminUserName) isCheckForApproval = false;
    });

    if (!isCheckForApproval) {
      const unauthorizedEmails = selectedNotes
        .filter(x => x.approvalEmail !== adminUserName)
        .map(x => x.approvalEmail)
        .join(', ');

      this.swalServices.Error(`You are not authorized to approve/reject these credit notes: ${unauthorizedEmails}`);
      return;
    }

    // Build request template
    const baseRequest = {
      updatedBy: adminUserId,
      updatedAt: moment().format("yyyy-MM-DD"),
      updatedAppId: 114,
      creditNoteStatusId: identity === 'Reject' ? 6 : 2,
      creditNoteImage: identity === 'Approve' ? this.state.filePath : '',
      comments: identity === 'Approve' ? this.state.comments : '',
    };

    try {
      // Loop over selected credit notes sequentially
      for (const note of selectedNotes) {
        const request = { ...baseRequest, financeCreditNoteId: [ note.financeCreditNoteId ] };

        const response = await this.financeService.financeApproveRejectCreditNoteApproval(request);

        if (response.statusCode === 200 && response.responseItem?.responseContent) {
          // Process each returned credit note one by one
          for (const item of response.responseItem.responseContent) {
            await this.getFinanceCreditNoteById(item.financeCreditNoteId);
          }
        } else {
          this.swalServices.Error("Something went wrong during approval/rejection.");
        }
      }

      // After all processing, update state/UI
      this.setState({
        isRejected: identity === 'Reject',
        isApprove: identity === 'Approve',
        isApproveCreditNote: false,
        comments: '',
        filePath: null,
      }, () => this.getAllFinanceCreditNoteList());

    } catch (error) {
      console.error(error);
      this.swalServices.Error("An error occurred during processing.");
    }
  };


  financeUpdateStatusForCreditNote = (value) => {
    let request = {
      financeCreditNoteId: value,
      creditNoteStatusId: 5,
    };
    this.financeService.financeUpdateStatusForCreditNote(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.swalServices.Success("Credit note status updated.");
        this.getAllFinanceCreditNoteList();
      } else {
        this.swalServices.Error("Something went wrong.");
      }
    })
  }
  financeGetCreditNoteInvoice = (value) => {
    let request = [];
    request.push(value);
    if (isNullString(value) !== "") {
      this.financeService.financeGetCreditNoteInvoice(request).then((response) => {
        if (response.data !== null && response.status === 200) {
          var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss")

          var filename = "";
          filename = `Credit-Note-${formattedDate}`;

          var file = new Blob([ response.data ], { type: "application/pdf" });

          URL.createObjectURL(file);
          window.open(URL.createObjectURL(file), "_blank");

          saveAs(file, filename + ".pdf");
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
    else {
      this.swalServices.Error("No Invoice is Available");
    }
  }

  addMembershipCreditNoteApprovalRecordsForBatchJob = (financeCreditNoteId) => {
    let request = [ financeCreditNoteId ];
    this.financeService.addMembershipCreditNoteApprovalRecordsForBatchJob(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
      }
      else {
        this.swalServices.Error(response.message);
      }
    });
  }

  componentDidMount() {


    let cookie = getAuthProps();
    let adminUserId = cookie?.adminUserId ?? null;
    let currentAdminEmail = cookie?.userName ?? null;
    let currentAdminName = cookie?.name ?? null;
    this.setState({ currentAdminEmail: currentAdminEmail, currentAdminName: currentAdminName, adminUserId: adminUserId })
    this.getFinanceCreditNoteStatusList();
  }

  handleChange = (event) => {
    let { name, value } = event.target;
    let detail = { ...this.state.pagination };
    detail[ name ] = value;
    this.setState({ pagination: detail });
  }

  handleChangeInDropdown = (id, drpIdentity) => {
    let detail = { ...this.state.pagination };
    detail.creditNoteStatusId = id;
    this.setState({ pagination: detail });
  }

  setPagination = (newPagination) => {

    this.setState({ pagination: newPagination }, () => { this.getAllFinanceCreditNoteList() });
  };

  actionClick = (index, value, option, event) => {
    if (option === "View Credit Note" || option === "Processing") {
      if (value && value > 0) {
        this.setState({
          route: `/financial/CreditNoteManagement/CreditNoteId?=${encryptAES(value)}`,
        });
      }
    }
    if (option === "Reject") {
      this.financeRejectCreditNoteApproval(value);
    }
    if (option === "Closed") {
      this.financeUpdateStatusForCreditNote(value);
    }
  };

  actions = (element, index, value) => {
    return element !== "financeCreditNoteId" ? null : (
      <div className="relative w-full credit-note-action-dropdown">
        <ActionContainer>
          <>
            {(this.state.creditNoteList.find(x => x.financeCreditNoteId === value)).financeCreditNoteStatus === 'Pending Approval' ?

              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdownApproved}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
              :
              (<>
                {(this.state.creditNoteList.find(x => x.financeCreditNoteId === value)).financeCreditNoteStatus === 'Sent' ?
                  <DropdownAction
                    key={index}
                    value={value}
                    id={index}
                    index={index}
                    options={this.state.actionDropdownForSent}
                    align="right"
                    onOptionClick={this.actionClick.bind(this)}
                  />
                  :
                  (<>
                    {(this.state.creditNoteList.find(x => x.financeCreditNoteId === value)).financeCreditNoteStatus === 'Rejected' ?
                      <DropdownAction
                        disabled={true}
                      />
                      :
                      (<>
                        <DropdownAction
                          key={index}
                          value={value}
                          id={index}
                          index={index}
                          options={this.state.actionDropdownApproved}
                          align="right"
                          onOptionClick={this.actionClick.bind(this)}
                        />
                      </>)
                    }

                  </>)
                }
              </>)
            }
          </>
        </ActionContainer>
      </div>
    );
  };

  select = (element, index) => {
    if (element !== "selectRow") {
      return null;
    }

    const row = this.state.creditNoteList[index];
    const value = row.financeCreditNoteId;

    return (
      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#000000]">
        <input
          name="isRequireQuotation"
          type="checkbox"
          className="cursor-pointer h-6 w-6 rounded check-box-custom"
          onChange={() => this.selectSingleRows(value)}
          checked={row.isSelected === true}
        />
      </td>
    );
  };

  selectSingleRows = (value) => {
    let getAllRows = [ ...this.state.creditNoteList ];
    let check = getAllRows.find(x => x.financeCreditNoteId === value)
    let checkedHeader = true;
    if (check.isSelected) {
      getAllRows.map((x) => {
        if (x.financeCreditNoteId === value) {
          x.isSelected = false;
        }
        return x;
      })

      this.setState({ isRejected: true, isApprove: true });

    } else {
      getAllRows.map((x) => {
        if (x.financeCreditNoteId === value) {
          x.isSelected = true;
        }
        return x;
      })
    }
    let isCheck = false;
    getAllRows.map((x) => {
      if (x.isSelected === true) {
        if (x.financeCreditNoteStatus === 'Approved' || x.financeCreditNoteStatus === 'Rejected' || x.financeCreditNoteStatus === 'Closed' || x.financeCreditNoteStatus === 'Sent') {
          isCheck = true;
        } else {
          this.setState({ isRejected: false, isApprove: false });
        }
      } else {
        checkedHeader = false;
      }
      return x;
    })

    if (isCheck) {
      this.setState({ isRejected: isCheck, isApprove: isCheck });
    }
    this.setState({ creditNoteList: getAllRows, checkedHeader: checkedHeader });
  }

  selectAllRows = () => {
    let getAllRows = [ ...this.state.creditNoteList ];
    let isAnyApproveReject = 0;
    if (this.state.checkedHeader) {
      getAllRows.map((item) => {
        item.isSelected = false;
        return item;
      });
      this.setState({ creditNoteList: getAllRows, checkedHeader: false });
    } else {
      getAllRows.map((item) => {
        item.isSelected = true;
        if (item.financeCreditNoteStatus === 'Approved' || item.financeCreditNoteStatus === 'Rejected') {
          isAnyApproveReject += 1;
        }
        return item;
      });
      if (isAnyApproveReject > 0) {
        this.setState({ isRejected: true, isApprove: true });
      } else {
        this.setState({ isRejected: false, isApprove: false });
      }
      this.setState({ creditNoteList: getAllRows, checkedHeader: true });
    }
  }

  render() {
    if (this.state.route !== "") {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section finance-body-sec">
        <div className="bg-white pb-2 mt-10">
          <div className="grid grid-cols-12 gap-6 w-full items-center px-8 pt-10">
            <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
              <h2 className="input-title mb-3">
                Status
              </h2>
              <DropdownSelect
                drpIdentity="Status"
                optionArray={this.state.creditNoteStatusList}
                setFilterParameters={this.handleChangeInDropdown.bind(this)}
                value={this.state.pagination.creditNoteStatusId}
              />
            </div>
            <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
              <h2 className="input-title mb-3">
                Credit Note Number
              </h2>
              <input
                id="default"
                name="creditNoteNumber"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                value={this.state.pagination.creditNoteNumber}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
              <h2 className="input-title mb-3">
                Search
              </h2>
              <input
                id="default"
                name="searchText"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                value={this.state.pagination.searchText}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
              <h2 className="input-title mb-3">
                Approval Email
              </h2>
              <input
                id="default"
                name="approvalEmailFilter"
                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                type="text"
                value={this.state.pagination.approvalEmailFilter}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-6 w-full items-end px-8 pb-12">
            <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
              <div className="mt-8 flex items-center justify-end w-full">
                <button className="btn btn-blue text-xl border text-white "
                  onClick={() => { this.getAllFinanceCreditNoteList() }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Table Section Start */}
        <div className="mt-10 credit-note-approval-table">
          <Table
            columns={[
              { name: "selectRow", title: <Checkbox handleCheckbox={() => this.selectAllRows()} checkedHeader={this.state.checkedHeader} /> },
              { name: "creditNoteNumber", title: "Credit Note Number" },
              { name: "name", title: "Created By" },
              { name: "approvalDate", title: "Approval Date" },
              { name: "invoiceNum", title: "Invoice Number" },
              { name: "companyName", title: "Company Name" },
              { name: "contactPerson", title: "Contact Person" },
              { name: "creditNoteTotalRefund", title: "Credit Amount" },
              { name: "creditNoteMonth", title: "Created Date" },
              { name: "creditNoteOpenCreditAmout", title: "Open Credit" },
              { name: "financeCreditNoteStatus", title: "Status" },
              { name: "financeCreditNoteId", title: "Actions" },
            ]}
            rows={this.state.creditNoteList}
            isLoading={this.state.isLoading}
            sortingColumns={[ "status" ]}
            pagination={this.state.pagination}
            totalResultes={this.state.totalResults}
            totalCount={this.state.totalResults}
            setPagination={this.setPagination.bind(this)}
            customScope={[
              {
                column: "financeCreditNoteId",
                renderTableData: this.actions.bind(this),
              },
              {
                column: "selectRow",
                renderTableData: this.select.bind(this),
                valueColumnName: "financeCreditNoteId",
              },
            ]}
            isRequiredButton1={true}
            buttonText1="Reject"
            button1Click={() => { this.financeApproveRejectCreditNoteApproval("Reject") }}
            button1Disable={this.state.isRejected}
            isRequiredButton2={true}
            buttonText2="Approve"
            button2Click={() => { this.approveCreditNote() }}
            button2Disable={this.state.isApprove}
          />
        </div>
        {/*Table Section End */}

        <div className="Approve-Credit-Note-modal">
          <ModalBasic
            id="ApproveCreditNote"
            modalOpen={this.state.isApproveCreditNote}
            setModalOpen={() => this.setState({ isApproveCreditNote: false })}
            title="Approve Credit Note"
          >
            <div className="grid grid-span-12 gap-6 p-5 pb-10">
              <div className="col-span-12 mb-5">
                <div className="items-center mb-5">
                  <label className="text-[#000000] text-[16px] mobile-14 md:mb-5 inline-block">
                    File 1
                  </label>
                  <div className="flex items-center disabled-input">
                    <input
                      className="w-full custom-input"
                      type="text"
                      name=""
                      value={this.state.fileDisplayName}
                      disabled
                    />
                    <div>
                      <ValidationText
                        error={this.state.validState.error.fileDisplayName}
                      />
                    </div>
                    <div className="flex items-center justify-center ml-4 ">
                      <form className="custom-uploader custom-file-upload-btn flex justify-center items-center text-center btn btn-blue-border">
                        <label
                          htmlFor={`upload_File_For_CreditNote`}
                          className="text-uplod block text-sm text-[#005B9C] w-full whitespace-nowrap"
                        >
                          Select File
                        </label>

                        <input
                          className="sr-only"

                          id={`upload_File_For_CreditNote`}
                          type="file"
                          onChange={(event) => this.onFileChange(event)}
                        />
                      </form>
                    </div>
                  </div>
                </div>
                <div className="items-center">
                  <label className="text-[#000000] text-[16px] mobile-14 md:mb-5 inline-block">
                    Comments
                    <span className="text-[#c00000]">*</span>
                  </label>
                  <textarea
                    className="w-full"
                    placeholder="Comments"
                    id=""
                    rows="5"
                    name="comments"
                    value={this.state.comments}
                    onChange={(e) => { this.setState({ comments: e.target.value }) }}
                    onBlur={() => this.validateFieldOutstandingDetails("comments")}
                  />
                  <div>
                    <ValidationText
                      error={this.state.validState.error.comments}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-12 flex justify-center">
                <button class="w-32 px-7 py-2 btn-sm btn-blue text-lg text-white"
                  onClick={() => {
                    this.financeApproveRejectCreditNoteApproval("Approve")
                  }}
                >Approve</button>
              </div>
            </div>

          </ModalBasic>
        </div>
      </div>
    );
  }
}
